import { Injectable } from '@angular/core';
import { InvoiceHttpService } from '../http/invoice.http.service';
import { Observable } from 'rxjs';
import { CompanyData } from '../model/interface/company-data.interface';

@Injectable({
  providedIn: 'root'
})
export class InvoiceDataProvider {
  constructor(private httpService: InvoiceHttpService) {}

  public getCompanyData(taxId: string): Observable<CompanyData> {
    return this.httpService.getCompanyData(taxId);
  }
}
